import '../styles/PageGlobal.css';
import './TVADetailsEditPage.css';
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import TVACountryPicker from '../components/TVACountryPicker';
import { TVAService } from '../services/TVAService.js';

export default function TVADetailsEditPage() {
  const { tva_id } = useParams();
  const navigate = useNavigate();
  const [showCountryPicker, setShowCountryPicker] = useState(false);
  
  const [form, setForm] = useState({ 
    produitReference: '', 
    codeDouane: '', 
    ddomRate: '', 
    daRate: '', 
    tvaRate: '', 
    tvaState: null 
  });
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTVA = useCallback(async () => {
    const service = new TVAService();
    setLoading(true);
    try {
      const data = await service.getTVAById(tva_id);
      setForm({
        produitReference: data.produitReference || '',
        codeDouane: data.codeDouane || '',
        ddomRate: data.ddomRate ?? '',
        daRate: data.daRate ?? '',
        tvaRate: data.tvaRate ?? '',
        tvaState: data.tvaState || null
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [tva_id]);

  useEffect(() => { fetchTVA(); }, [fetchTVA]);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSave = async () => {
    const service = new TVAService();
    setLoading(true);
    try {
      const payload = {
        id: parseInt(tva_id, 10), // 🟢 Empêche le bug Hibernate
        produitReference: form.produitReference,
        codeDouane: form.codeDouane,
        ddomRate: form.ddomRate === '' ? null : parseFloat(form.ddomRate),
        daRate: form.daRate === '' ? null : parseFloat(form.daRate),
        tvaRate: form.tvaRate === '' ? null : parseFloat(form.tvaRate),
        tvaState: form.tvaState // Doit être un objet { id: X, code: '...', label: '...' }
      };
      await service.updateTVA(tva_id, payload);
      alert("TVA modifiée avec succès !");
      navigate("/tva_list");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Confirmer la suppression ?")) return;
    try {
      await new TVAService().deleteTVA(tva_id);
      navigate("/tva_list");
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="tva-error">{error}</div>;

  return (
    <div className="containerMain tva-edit-container">
      <h1 className="tva-edit-title">Détails / Édition TVA</h1>
      <p className="tva-edit-subtitle">Ceci est un contenu protégé</p>

      {showCountryPicker && (
        <TVACountryPicker 
          onClose={() => setShowCountryPicker(false)} 
          onSelect={(stateObj) => { 
            setForm(prev => ({...prev, tvaState: stateObj})); 
            setShowCountryPicker(false); 
          }} 
        />
      )}

      <div className="tva-edit-actions">
        <ReferenceButton onClick={() => setShowCountryPicker(true)}>
          Modifier l'État/Pays ({form.tvaState?.label || 'Aucun'})
        </ReferenceButton>
      </div>

      <div className="tva-edit-form">
        <div className="tva-edit-row">
          <label>Référence Produit</label>
          <input name="produitReference" value={form.produitReference} onChange={handleChange} />
        </div>
        <div className="tva-edit-row">
          <label>Code Douane</label>
          <input name="codeDouane" value={form.codeDouane} onChange={handleChange} />
        </div>
        <div className="tva-edit-row">
          <label>OM (%)</label>
          <input type="number" step="0.01" name="ddomRate" value={form.ddomRate} onChange={handleChange} />
        </div>
        <div className="tva-edit-row">
          <label>DA (%)</label>
          <input type="number" step="0.01" name="daRate" value={form.daRate} onChange={handleChange} />
        </div>
        <div className="tva-edit-row">
          <label>TVA (%)</label>
          <input type="number" step="0.01" name="tvaRate" value={form.tvaRate} onChange={handleChange} />
        </div>
      </div>

      <div className="tva-edit-footer">
        <button className="tva-btn tva-btn-blue" onClick={handleSave} disabled={loading}>{loading ? '...' : 'Enregistrer'}</button>
        <button className="tva-btn tva-btn-red" onClick={handleDelete} disabled={loading}>Supprimer</button>
        <button className="tva-btn tva-btn-grey" onClick={() => navigate("/tva_list")} disabled={loading}>Annuler</button>
      </div>
    </div>
  );
}